<template>
  <b-modal
    :visible="visible"
    size="xl"
    centered
    hide-footer
    title="Desempenho"
    @hide="$emit('close')"
  >
    <div class="text-center mb-4">
      <b-button size="sm" @click="baixarImagem">
        <i class="icofont-download"></i>
        Baixar imagem
      </b-button>
    </div>

    <div ref="cardDesempenho" class="desempenho-card">
      <img :src="imagemDesempenho" class="desempenho-img" />

      <div class="podio-info">
        <div class="podio-item podio-regional">
          {{ posicaoRegional }}º na Regional
        </div>

        <div class="podio-item podio-uf">
          {{ posicaoUf }}º {{ artigoEstado }} {{ municipio?.uf }}
        </div>

        <div class="podio-item podio-br">
          {{ posicaoBrTxt }}
        </div>
      </div>

      <div
        class="nome-municipio-faixa"
        :class="{ 'texto-preto': isImagemBranca }"
      >
        {{ nomeMunicipioFaixa }}
      </div>

      <div class="quadrimestre-info">
        {{ quadrimestreTexto }}
      </div>

      <div class="equipes-info">
        <div
          v-for="(box, index) in boxesClassificacao"
          :key="box.key"
          class="equipe-box"
          :class="[
            box.class,
            classeLinhas(box.dados),
            classeDigitos(box.dados),
            { 'sem-equipes': deveExibirSeta(index) },
          ]"
        >
          <template v-if="equipesPorClassificacao(box.dados).length">
            <div
              v-for="item in equipesPorClassificacao(box.dados)"
              :key="item.tipo"
              class="equipe-linha"
            >
              <strong>{{ item.quantidade }}</strong>
              <span>{{ item.tipo }}</span>
            </div>
          </template>

          <div v-else-if="deveExibirSeta(index)" class="equipe-seta">
            <i class="icofont-long-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>

    <p class="text-center mt-2">
      <strong style="color: red">Atenção:</strong> Recomendamos acessar o
      sistema por um computador para baixar a imagem.
    </p>
  </b-modal>
</template>

<script>
import html2canvas from 'html2canvas'

export default {
  name: 'ModalDesempenho',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    municipio: {
      type: Object,
      default: null,
    },
    page: {
      type: String,
      default: '',
    },
    regiao: {
      type: String,
      default: '',
    },
  },

  computed: {
    imagemDesempenho() {
      if (this.melhorPosicao === 1) {
        return require('@/assets/images/cofinanciamento-federal/ouro.jpg')
      }

      if (this.melhorPosicao === 2) {
        return require('@/assets/images/cofinanciamento-federal/prata.jpg')
      }

      if (this.melhorPosicao === 3) {
        return require('@/assets/images/cofinanciamento-federal/bronze.jpg')
      }

      return require('@/assets/images/cofinanciamento-federal/branco.jpg')
    },

    posicaoRegional() {
      return Number(this.municipio?.posicao_regiao_saude || 0)
    },

    posicaoUf() {
      return Number(this.municipio?.posicao_uf || 0)
    },

    posicaoBr() {
      return Number(this.municipio?.posicao_br || 0)
    },

    posicaoBrTxt() {
      if (!this.municipio) {
        return ''
      }

      const siglas = {
        Norte: 'N',
        Nordeste: 'NE',
        'Centro-Oeste': 'CO',
        Sudeste: 'SE',
        Sul: 'S',
      }

      if (
        this.regiao &&
        this.municipio.posicao_faixa_pop < this.municipio.posicao_br
      ) {
        return `${this.municipio.posicao_faixa_pop_regiao_ibge}º no ${
          siglas[this.regiao]
        } ${this.municipio.int_faixa_port_pop}K`
      }

      if (this.municipio.posicao_faixa_pop < this.municipio.posicao_br) {
        return `${this.municipio.posicao_faixa_pop}º no BR ${this.municipio.int_faixa_port_pop}K`
      }

      return `${this.municipio.posicao_br}º no BR`
    },

    nomeMunicipioFaixa() {
      const nome = `${this.municipio?.municipio || ''} - ${
        this.municipio?.uf || ''
      }`

      if (!this.isImagemBranca) {
        return nome
      }

      return `${this.melhorPosicao}º ${nome}`
    },

    melhorPosicao() {
      return Math.min(
        this.posicaoRegional || 999,
        this.posicaoUf || 999,
        this.posicaoBr || 999
      )
    },

    artigoEstado() {
      const estadosFemininos = ['BA', 'PB']

      return estadosFemininos.includes(this.municipio?.uf) ? 'na' : 'no'
    },

    quadrimestreTexto() {
      return this.municipio?.quadrimestre
        ? `${this.municipio.quadrimestre}`
        : ''
    },

    boxesClassificacao() {
      return [
        {
          key: 'regular',
          class: 'box-regular',
          dados: this.municipio?.regular,
        },
        {
          key: 'suficiente',
          class: 'box-suficiente',
          dados: this.municipio?.suficiente,
        },
        {
          key: 'bom',
          class: 'box-bom',
          dados: this.municipio?.bom,
        },
        {
          key: 'otimo',
          class: 'box-otimo',
          dados: this.municipio?.otimo,
        },
      ]
    },

    isImagemBranca() {
      return this.melhorPosicao > 3
    },
  },
  methods: {
    /**
     * Indica se deve exibir a seta da classificação.
     *
     * A seta é exibida quando a classificação atual não possui equipes
     * e todas as classificações anteriores também não possuem equipes.
     *
     * @param {Number} index
     * @returns {Boolean}
     */
    deveExibirSeta(index) {
      for (let i = 0; i <= index; i++) {
        if (
          this.equipesPorClassificacao(this.boxesClassificacao[i].dados).length
        ) {
          return false
        }
      }

      return true
    },

    /**
     * Retorna as equipes existentes para uma classificação.
     *
     * Os quantitativos de eSF/eAP, CVAT, eMulti e eSB são
     * organizados para exibição dentro da imagem.
     *
     * @param {Object|null} item Dados da classificação.
     * @returns {Array}
     */
    equipesPorClassificacao(item) {
      if (!item) return []

      const equipes = []

      const esf = Number(item.esf_qual || 0) + Number(item.eap_qual || 0)

      const cvat = Number(item.esf_cvat || 0) + Number(item.eap_cvat || 0)

      const multi = Number(item.emulti_qual || 0)

      const esb = Number(item.esb_qual || 0)

      if (esf > 0) {
        equipes.push({
          tipo: 'eSF',
          quantidade: esf,
        })
      }

      if (cvat > 0) {
        equipes.push({
          tipo: 'CVAT',
          quantidade: cvat,
        })
      }

      if (multi > 0) {
        equipes.push({
          tipo: 'eMulti',
          quantidade: multi,
        })
      }

      if (esb > 0) {
        equipes.push({
          tipo: 'eSB',
          quantidade: esb,
        })
      }

      return equipes
    },

    /**
     * Retorna a classe CSS conforme a quantidade de linhas
     * exibidas no bloco da classificação.
     *
     * @param {Object|null} item Dados da classificação.
     * @returns {String}
     */
    classeLinhas(item) {
      const totalLinhas = this.equipesPorClassificacao(item).length

      return `linhas-${totalLinhas}`
    },

    /**
     * Retorna a classe CSS conforme a quantidade de dígitos
     * do maior quantitativo exibido.
     *
     * @param {Object|null} item Dados da classificação.
     * @returns {String}
     */
    classeDigitos(item) {
      const equipes = this.equipesPorClassificacao(item)

      if (!equipes.length) {
        return 'digitos-1'
      }

      const maiorDigito = Math.max(
        ...equipes.map((equipe) => String(equipe.quantidade).length)
      )

      if (maiorDigito >= 4) {
        return 'digitos-4'
      }

      if (maiorDigito === 3) {
        return 'digitos-3'
      }

      if (maiorDigito === 2) {
        return 'digitos-2'
      }

      return 'digitos-1'
    },

    /**
     * Gera uma imagem PNG do card de desempenho e realiza
     * o download para o usuário.
     *
     * @returns {Promise<void>}
     */
    async baixarImagem() {
      const elemento = this.$refs.cardDesempenho

      if (!elemento) return

      const canvas = await html2canvas(elemento, {
        useCORS: true,
        scale: 2,
        backgroundColor: null,
      })

      const link = document.createElement('a')
      link.download = `${this.municipio?.quadrimestre}-desempenho-${
        this.municipio?.municipio || 'municipio'
      }.png`
      link.href = canvas.toDataURL('image/png')
      link.click()
    },
  },
}
</script>

<style scoped lang="scss">
.desempenho-card {
  position: relative;
  width: 100%;
  max-width: 900px;
  margin: 0 auto;

  .desempenho-img {
    width: 100%;
    display: block;
    border-radius: 12px;
  }

  .podio-info {
    position: absolute;
    top: 26.5%;
    left: 0;
    right: 0;
    color: #fff;
    font-size: 21px;
    font-weight: 900;
    text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.55);

    .podio-item {
      position: absolute;
      white-space: nowrap;

      &.podio-regional {
        left: 21%;
      }

      &.podio-uf {
        left: 53%;
        transform: translateX(-50%);
      }

      &.podio-br {
        left: 70%;
      }
    }
  }

  .nome-municipio-faixa {
    position: absolute;
    top: 16.3%;
    left: 50%;
    transform: translateX(-50%);

    display: flex;
    align-items: center;
    justify-content: center;

    height: 6.2%;

    color: #fff;
    font-size: 34px;
    font-weight: 900;
    text-align: center;
    text-transform: uppercase;
    line-height: 1.1;
    text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.55);

    &.texto-preto {
      color: #000;
      text-shadow: none;
    }
  }

  .quadrimestre-info {
    position: absolute;
    top: 31.6%;
    left: 50%;
    transform: translateX(-50%);

    width: 190px;
    height: 34px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #fff;
    font-size: 35px;
    font-weight: 800;
    text-align: center;
    text-transform: uppercase;
    line-height: 1;
    text-shadow: 1px 2px 4px rgba(0, 0, 0, 0.55);
  }

  .equipes-info {
    position: absolute;
    inset: 0;

    .equipe-box {
      position: absolute;

      width: 13.2%;
      height: 8.8%;

      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      text-align: center;
      color: #111827;
      font-weight: 800;
      line-height: 1.05;
      gap: 3px;

      .equipe-linha {
        display: flex;
        align-items: baseline;
        justify-content: center;
        gap: 3px;
        white-space: nowrap;
      }

      strong,
      span {
        line-height: 1;
      }

      strong {
        font-size: clamp(8px, 1vw, 21px);
        line-height: 1;
      }

      span {
        font-size: clamp(8px, 1vw, 13px);
        line-height: 1;
      }

      &.box-regular {
        top: 58.9%;
        left: 20%;
        transform: translate(-30%, -50%);
      }

      &.box-suficiente {
        top: 55%;
        left: 40%;
        transform: translate(-30%, -50%);
      }

      &.box-bom {
        top: 50.7%;
        left: 59.5%;
        transform: translate(-30%, -50%);
      }

      &.box-otimo {
        top: 46.3%;
        left: 80.2%;
        transform: translate(-30%, -50%);
      }

      .equipe-seta {
        position: absolute;
      }

      &.sem-equipes {
        align-items: center;
        justify-content: center;
        transform: translate(-50%, -50%);

        .equipe-seta {
          position: absolute;
          top: 50%;
          left: 50%;

          transform: translate(-50%, -50%);

          display: flex;
          align-items: center;
          justify-content: center;

          width: auto;
          height: auto;

          i {
            font-size: 40px;
            font-weight: bold;
            line-height: 1;
            display: block;
            color: green;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 656px) {
  .equipe-box {
    gap: 1px !important;
    span,
    strong {
      font-size: 6px !important;
    }
  }
}

@media (max-width: 767px) {
  .desempenho-card {
    .podio-info {
      font-size: 8px;
    }

    .nome-municipio-faixa {
      font-size: 12px;
    }

    .quadrimestre-info {
      height: auto;
      font-size: 14px;
    }
  }
}

@media (min-width: 768px) and (max-width: 1023px) {
  .desempenho-card {
    .podio-info {
      font-size: 10px;
    }

    .nome-municipio-faixa {
      font-size: 16px;
    }

    .quadrimestre-info {
      height: auto;
      font-size: 18px;
    }

    .equipe-box {
      gap: 0px !important;
    }
  }
}

@media (min-width: 1024px) and (max-width: 1265px) {
  .desempenho-card {
    .podio-info {
      font-size: 19px;
    }

    .nome-municipio-faixa {
      font-size: 26px;
    }

    .quadrimestre-info {
      font-size: 32px;
    }
  }
}
</style>
